export default __webpack_public_path__ + "static/media/exampleEN.53e5b728.gif";